export default "__VITE_ASSET__21a1bd43__"